export default "__VITE_ASSET__367db93a__"